// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Pf_6","icon":"styles_icon__Nm0h3"};